import { Badge, Container, Section } from '@resolute/ui';

import { Reveal, StaggerGroup, StaggerItem } from '@/components/motion/reveal';

const STEPS = [
  {
    title: 'Discover',
    stage: 'Search & shortlist',
    body: 'Filter across price, city, BHK and verified-only inventory, then compare shortlisted properties side by side with real facts, not marketing copy.',
    tags: ['Verified listings', 'Compare tool', 'Saved searches'],
  },
  {
    title: 'Evaluate',
    stage: 'Verify & model',
    body: 'Every RERA number, developer track record and yield projection is available before you ever schedule a visit.',
    tags: ['RERA documents', 'ROI calculator', 'Price trends'],
  },
  {
    title: 'Engage',
    stage: 'Visit & advise',
    body: 'Book a site visit or callback straight from the listing — a dedicated advisor responds within one business day.',
    tags: ['Site visits', 'Dedicated advisor', '1-business-day response'],
  },
  {
    title: 'Close',
    stage: 'Close with confidence',
    body: 'From offer to registration, we keep the documentation trail intact so nothing gets lost between broker, buyer and builder.',
    tags: ['Documentation trail', 'NRI support', 'Post-sale follow-up'],
  },
];

export function AboutProcess() {
  return (
    <Section spacing="md" className="border-y border-border bg-muted/30">
      <Container>
        <div className="grid gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-14">
          <Reveal>
            <p className="text-sm font-medium uppercase tracking-widest text-secondary">
              How we work
            </p>
            <h2 className="mt-2 text-balance font-display text-display-sm font-semibold tracking-tight">
              From first search to keys in hand.
            </h2>
            <p className="mt-4 text-lg text-muted-foreground">
              Our platform is structured to remove the friction points that slow down traditional
              property buying — the unverifiable brochures, the scattered paperwork, and the
              silence after a site visit.
            </p>
          </Reveal>

          <StaggerGroup className="relative space-y-10">
            <div
              aria-hidden="true"
              className="absolute bottom-2 left-[21px] top-2 w-px bg-border"
            />
            {STEPS.map((step, i) => (
              <StaggerItem key={step.title} className="relative flex gap-5">
                <span className="relative flex size-11 shrink-0 items-center justify-center rounded border border-border bg-card text-sm font-semibold text-foreground">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div className="pt-1">
                  <h3 className="text-lg font-semibold tracking-tight">
                    {step.title}
                    <span className="ml-2 text-xs font-medium uppercase tracking-wide text-muted-foreground">
                      {step.stage}
                    </span>
                  </h3>
                  <p className="mt-2 text-muted-foreground">{step.body}</p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {step.tags.map((tag) => (
                      <Badge key={tag} variant="outline" className="uppercase tracking-wide">
                        {tag}
                      </Badge>
                    ))}
                  </div>
                </div>
              </StaggerItem>
            ))}
          </StaggerGroup>
        </div>
      </Container>
    </Section>
  );
}
